import {Locales} from '@netx/core-next/locales';

export const EmailFieldLabel = Locales((i18n) => ({
	EMAIL: i18n('i18n.email'),
}));

export const EmailFieldError = Locales((i18n) => ({
	DUPLICATE: i18n('i18n.emailAddressError_duplicate', {
		defaultValue: 'Duplicate email',
	}),
	SOME_DUPLICATE: (emailAddresses: string[]) =>
		i18n('i18n.emailAddressError_someDuplicate', {
			emailAddresses: emailAddresses.join(', '),
			defaultValue:
				'Some email addresses were already present: __emailAddresses__',
		}),
	SOME_INVALID: (emailAddresses: string[]) =>
		i18n('i18n.emailAddressError_someInvalid', {
			emailAddresses: emailAddresses.join(', '),
			defaultValue:
				'Some email addresses could not be added: __emailAddresses__',
		}),
}));
